module.exports = __webpack_public_path__ + "img/489.7770ec79.png";